export const getIdFromPath = (path = "", apiPath: string) => path.replace(`${apiPath}/`, "");

export const getLastIdFromPath = (path: string) => {
  const splitted = path.split("/");

  return splitted[splitted.length - 1];
};

export const isVowel = (char: string) => {
  return ["a", "e", "i", "o", "u"].includes(char.toLowerCase());
};
